import React from 'react';
import {Databox,LoadGraphic} from '../components-static/Common';
import PublicLayoutPage from '../components-app/PublicPageLayout';
import {Link} from 'react-router-dom';
import u from '../utilities/Utilities';
import qs from 'query-string';

export default class ResetPassword extends React.Component{

    state={
        loading:true,
        loadText: "Attempting to reset password...",
    };

    componentDidMount(e){
        const query = qs.parse(this.props.location.search);
        const passToken = query.token;

        if(passToken) {
            u.post({
                url: "/noauth/commit-password",
                data: {
                    token: passToken
                },
                success: (callback)=>{
                    this.setState({loading:false});
                },
                error: (error, status)=>{
                    this.setState({loadText: error});
                }
            });
        }
        else{
            this.setState({loadText:"Error! Please access this page from the link sent to your email"});
        }
    }

    render(){
        return(
            <PublicLayoutPage url="/reset" title="Reset Password">
                <div>
                    <Databox active={true} align="center" padding="0px 20px 40px 20px" margin="100px auto" width="1000px" maxWidth="90%">
                        <div>
                            <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                            <h2>
                                <img src="/images/input/confirm.png" style={{height:"60px",display:"inline-block",verticalAlign:"middle",margin:"20px"}}/>
                                <span style={{display:"inline-block",verticalAlign:"middle"}}>Password has been successfully reset</span>
                            </h2>
                            <div>Please <Link to="/login" title="Login here">click here</Link> to login</div>
                        </div>
                    </Databox>
                </div>
            </PublicLayoutPage>
        )
    }
}
